import Swiper from 'swiper/bundle'

export class Carousel {

    constructor(target = '.js-carousel', options = {}) {

        this.target = target;

        this.options = {
            slidesPerView: 1,
            spaceBetween: 40,
            slideClass: 'js-carousel__slide',
            wrapperClass: 'js-carousel__track',
            slideActiveClass: 'js-carousel__slide--active',
            noSwipingClass: 'js-carousel__no-swipe',
            navigation: {
                nextEl: '.js-carousel__next',
                prevEl: '.js-carousel__prev',
                disabledClass: 'js-carousel__control--disabled',
            },
            pagination: {
                el: '.js-carousel__pages',
                bulletClass: 'c-swiper__bullet',
                bulletActiveClass: 'c-swiper__bullet--active',
                clickable: true
            },
            ...options
        }

        this.observerOptions = {
            observer: {
                root: document.querySelector('body'),
                rootMargin: '0px',
                threshold: 0.01
            },
            removeTarget: true,
            ...options
        }
    }

    init() {

        this.sliders = [];
        this.el = Array.from(document.querySelectorAll(this.target));

        if (this.el.length > 0) {
            this.sliderObserver = new IntersectionObserver((entries, observer) => {
                this.create(entries, this)
            }, this.observerOptions);

            this.el.forEach($el => {
                this.sliderObserver.observe($el);
            });
        }


    }

    create(entries, instance) {
        entries.forEach((entry) => {
            if (entry.isIntersecting) {

                const $el = entry.target;
                const $container =  $el.querySelector('.js-carousel__container') ?? $el;
                const count = Array.from($el.querySelectorAll(`.${this.options.slideClass}`)).length;
                const items = parseInt($el.dataset.items) ?? 1;
                const speed = parseInt($el.dataset.auto);

                let options = {
                    ...this.options
                };

                if (count === 1) {
                    return false;
                }

                if (speed) {
                    options = {
                        ...options,
                        autoplay: {
                            delay: speed,
                        },
                    }
                }

                if (items >= 4) {
                    options = {
                        ...options,
                        breakpoints: {
                            480: {
                                slidesPerView: 1
                            },
                            720: {
                                slidesPerView: 2
                            },
                            1180: {
                                slidesPerView: 3
                            },
                            1420: {
                                slidesPerView: 4
                            },
                        },
                    }
                }
                if (items <= 2) {
                    options = {
                        ...options,
                        breakpoints: {
                            720: {
                                slidesPerView: 1
                            },
                            1180: {
                                slidesPerView: 2
                            },
                        },
                    }
                } else if (items === 3) {
                    options = {
                        ...options,
                        breakpoints: {
                            ...options.breakpoints,
                            780: {
                                slidesPerView: 2
                            },
                            1040: {
                                slidesPerView: 3
                            }
                        },
                    }
                }

                if(items === 1) {
                    options = {
                        ...options,
                        pagination: false,
                        spaceBetween: 0,
                        breakpoints: false,
                        effect: 'fade',
                    }
                }

                const $controls = $el.querySelector(`.c-slider__controls`);
                const $pager = $el.querySelector(`.js-carousel__pages`);
                if (count === 0) {
                    if ($controls) {
                        $controls.remove();
                    }
                    if ($pager) {
                        $pager.remove();
                    }
                }

                const carousel = new Swiper($container, options)

                this.sliders.push(carousel);
                this.sliderObserver.unobserve($container);
            }
        })
    }

    destroy() {
        if (this.el.length > 0) {
            this.sliderObserver.disconnect();
        }
        this.sliders.forEach(slider => {
            slider.destroy();
        })
    }
}
